var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"right-menu-banner",staticStyle:{"display":"block"},style:(_vm.style),on:{"mousedown":function($event){$event.stopPropagation();},"contextmenu":function($event){$event.preventDefault();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }